import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "@/shared/lib/cn";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  glass?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, glass, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-2xl p-6",
        glass
          ? "glass dark:glass-dark shadow-glass"
          : "bg-white border border-sand-200 shadow-sm dark:bg-sand-800 dark:border-sand-700",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);

Card.displayName = "Card";
